import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import * as DATA from '../utils/Data';
import './NewsList.css';

export default ({ newsItems }) => {
  return (
    <div className="news-list">
      {newsItems.map(({ slug, fecha, titulo, imagen }, i) => (
        <Card key={i}>
          <Link className="news-item" to={`notas/${slug}`}>
            <div className="l-news-header">
              <div
                className="news-item__img"
                style={{
                  backgroundImage: `url(${DATA.SERVER_URL + imagen.data.url})`
                }}
              />
            </div>
            <div className="l-news-main">
              <h3 className="news-item__title">{titulo}</h3>
            </div>
            <div className="l-news-footer">
              <div className="news-item__date">{fecha}</div>
              <div className="btn">Leer nota</div>
            </div>
          </Link>
        </Card>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NewsList.js